import { CasPage } from 'src/compass/shared/components';
import { SiteLayout } from 'src/compass/application';

import PublicUploadFilesContainer from './_publicUploadFiles/components/PublicUploadFilesContainer';

export default function PublicUploadFilesPage() {
  return (
    <SiteLayout>
      <CasPage title="Upload Files">
        <PublicUploadFilesContainer />
      </CasPage>
    </SiteLayout>
  );
}
